import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const AlertsRow = ({ alert, onClick }) => {
	const isClickable = !!onClick;

	const EventTitle = ({ title }) => (
		<Typography
			sx={{
				fontSize: '12px',
				color: 'text.primary',
				lineHeight: 1.45,
			}}
		>
			{title}
		</Typography>
	);

	const creationDatetime = alert?.event_time
		? new Date(alert.event_time).toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				hour: 'numeric',
				minute: '2-digit',
			})
		: null;

	const EventCreation = ({ datetime }) => (
		<Typography
			sx={{
				fontSize: '11px',
				color: 'text.secondary',
			}}
		>
			{datetime}
		</Typography>
	);

	const EventSubtitle = ({ subtitle }) => (
		<Typography
			sx={{
				fontSize: '11px',
				color: 'text.secondary',
			}}
		>
			{subtitle}
		</Typography>
	);

	const ListItemDot = () => (
		<Box
			sx={{
				width: 7,
				height: 7,
				minWidth: 7,
				borderRadius: '50%',
				backgroundColor: 'signal.gray',
				flexShrink: 0,
				mt: '4px',
			}}
		/>
	);

	return (
		<Box
			onClick={onClick}
			sx={{
				display: 'flex',
				alignItems: 'flex-start',
				gap: '9px',
				padding: '9px 15px',
				borderBottom: '0.5px solid',
				borderColor: 'border.light',
				'&:hover': {
					backgroundColor: 'background.subtle',
				},
				cursor: isClickable ? 'pointer' : 'default',
			}}
		>
			<ListItemDot />

			{/* content */}
			<Box sx={{ flex: 1, minWidth: 0 }}>
				<Box sx={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
					{alert.event?.event_title && (
						<EventTitle title={alert.event.event_title} />
					)}
				</Box>

				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: '6px',
						mt: '2px',
					}}
				>
					{creationDatetime && <EventCreation datetime={creationDatetime} />}

					{creationDatetime && alert.event?.event_subtitle ? ' · ' : ''}

					{alert.event?.event_subtitle && (
						<EventSubtitle subtitle={alert.event?.event_subtitle} />
					)}
				</Box>
			</Box>
		</Box>
	);
};

AlertsRow.propTypes = {
	alert: PropTypes.object,
	onClick: PropTypes.func,
};

export default AlertsRow;
